import React, { useEffect, useState } from "react";
import { LikeHeartIcon } from "./InlineIcons";

interface LikeButtonProps {
  initialCount: number;
  initiallyLiked: boolean;
  label: string;
  likedLabel: string;
  className?: string;
  onToggle?: (liked: boolean) => void;
}

const LikeButton = ({
  initialCount,
  initiallyLiked,
  label,
  likedLabel,
  className = "",
  onToggle,
}: LikeButtonProps) => {
  const [liked, setLiked] = useState(initiallyLiked);
  const [count, setCount] = useState(initialCount);
  const [interacted, setInteracted] = useState(false);

  useEffect(() => {
    setLiked(initiallyLiked);
    setCount(initialCount);
  }, [initialCount, initiallyLiked]);

  const toggleLike = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (onToggle) {
      onToggle(liked);
      setInteracted(true);
      return;
    }

    setLiked(!liked);
    setCount(liked ? Math.max(0, count - 1) : count + 1);
    setInteracted(true);
  };

  return (
    <button
      className={`${className}like-btn`}
      type="button"
      aria-pressed={liked}
      aria-label={
        interacted
          ? liked
            ? "You liked this"
            : "Like"
          : liked
            ? likedLabel
            : label
      }
      onClick={toggleLike}
    >
      <LikeHeartIcon />
      <span className="like-label">Like</span>
      <span className="like-count">{count}</span>
    </button>
  );
};

export default LikeButton;
